import { Link } from 'react-router';

import { useAuth } from '@/auth/useAuth';
import { Button } from '@/components/Button/Button';
import { Card } from '@/components/Card/Card';

import styles from './NotFound.module.css';

// An unknown address, and every refusal that must look like one. It leads back
// to where the reader can go from here.
export function NotFound() {
  const { user } = useAuth();

  return (
    <main className={styles.shell}>
      <Card className={styles.card} variant="elevated">
        <h1 className={styles.title}>Page not found</h1>
        <p className={styles.message}>
          There is no page at this address. The link may be out of date, or the
          address mistyped.
        </p>
        {/* Secondary, as the error screen's link is: the dark theme's primary
            button is white on a light blue, under 4.5:1. */}
        <div className={styles.actions}>
          {user ? (
            <Button as={Link} size="large" to="/app/courses" variant="secondary">
              Go to my courses
            </Button>
          ) : (
            <Button as={Link} size="large" to="/" variant="secondary">
              Go to the Kudu home page
            </Button>
          )}
        </div>
      </Card>
    </main>
  );
}
